/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === Math.floor(n) && (n >= 0 && n <= 1))
    return 1;
return 5;
}

export default ["ak",[["AN","EW"]],[["AN","EW"],u,["AN","ANW"]],[["K","D","B","W","Y","F","M"],["Kwe","Dwo","Ben","Wuk","Yaw","Fia","Mem"],["Kwasiada","Dwoada","Benada","Wukuada","Yawoada","Fiada","Memeneda"],["Kwe","Dwo","Ben","Wuk","Yaw","Fia","Mem"]],u,[["Ɔ","Ɔ","Ɔ","O","K","A","K","Ɔ","Ɛ","A","O","Ɔ"],["Ɔpɛpɔn","Ɔgyefoɔ","Ɔbɛnem","Oforisuo","Kɔtɔnimma","Ayɛwohomumu","Kutawonsa","Ɔsanaa","Ɛbɔ","Ahinime","Obubuo","Ɔpɛnimma"]],u,[["AK","KE"],u,["Ansa Kristo","Kristo Akyi"]],1,[6,0],["M/d/yy","MMM d, y","MMMM d, y","EEE, MMMM d, y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤#,##0.00","#E0"],"GHS","GH₵","Ghana Sidi",{"GHS":["GH₵"],"IQD":["Irak dinaa"],"JPY":["JP¥","¥"],"USD":["US$","$"],"XOF":["AAS"]},"ltr", plural];
